export default __webpack_public_path__ + "static/media/Turkey.9b19b0a3.jpg";